import { Circle, Fill, Stroke, Style, Text } from 'ol/style';

export const createStyle = (options) => {
    return new Style({
        image: options.image,
        text: options.text || undefined,
    });
};

export const createTextStyle = (text, color, offsetX = 0, offsetY = 0) => {
    return new Text({
        font: "10px helvetica,sans-serif",
        text: text,
        offsetX: offsetX,
        offsetY: offsetY,
        fill: new Fill({ color: color }),
    });
};

export const createCircleStyle = (radius, fillColor, strokeColor, opacity, additionalAttr = {}) => {
    return new Circle({
        radius: radius,
        stroke: new Stroke({
            color: `rgba(${strokeColor}, ${opacity})`,
            width: 2,
        }),
        fill: new Fill({
            color: `rgba(${fillColor}, ${opacity})`,
        }),
        ...additionalAttr,
    });
};